module.exports = __webpack_public_path__ + "static/media/subICloud4.6f751fff.png";